export default __webpack_public_path__ + "static/media/washStudioLogo.a28b6cfb.png";